/**
 * safeNext — Utilidad compartida para sanear parámetros `?next=` que
 * deciden redirecciones post-autenticación / post-checkout.
 *
 * Objetivo: evitar cualquier open-redirect fuera de NetScouters.
 *
 * Reglas:
 *  - Sólo se aceptan rutas INTERNAS relativas de la aplicación.
 *  - Rechaza URLs absolutas (http:, https:, ftp:, data:, javascript:, etc.).
 *  - Rechaza protocol-relative "//" y UNC "/\\".
 *  - Rechaza whitespace inicial y caracteres de control.
 *  - Valida contra un origen ficticio: si al resolver cambia de origen,
 *    la ruta era absoluta encubierta y se rechaza.
 *
 * La lógica es idéntica a la que ya se usaba en
 * `pages/public/checkout/CheckoutOutcomes.jsx` (consolidada aquí para
 * evitar duplicación cuando otras pantallas — Login/Register — también
 * necesitan honrar `?next=` de forma segura).
 *
 * Ejemplos aceptados:  "/eventos/foo/watch?v=abc", "/dashboard", "/planes"
 * Ejemplos rechazados: "http://x", "//evil.com", "javascript:alert(1)",
 *                      "\\foo", "  /x", "eventos/foo", ""
 */
export function sanitizeInternalNext(candidate) {
  if (typeof candidate !== 'string') return null;
  const raw = candidate;
  if (!raw) return null;
  if (raw !== raw.trimStart()) return null;
  if (!raw.startsWith('/')) return null;
  if (raw.startsWith('//')) return null;
  if (raw.startsWith('/\\')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x1f\x7f]/.test(raw)) return null;
  try {
    const base = 'https://internal.invalid';
    const u = new URL(raw, base);
    if (u.origin !== base) return null;
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return null;
  }
}

export default sanitizeInternalNext;
